import React from 'react'
import PropTypes from 'prop-types'
import { RadioBox } from '@jisr-hr/design-system'

const Radio = ({
  input: { onChange, value },
  radioValue,
  handleOnChange,
  errorMessage,
  designSystem,
  ...rest
}) => (
  <RadioBox
    {...rest}
    variant="simple"
    value={radioValue}
    checked={radioValue === value}
    onChange={(v) => {
      onChange(v)
      handleOnChange(v)
    }}
  />
)

Radio.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  handleOnChange: PropTypes.func,
  errorMessage: PropTypes.string,
  radioValue: PropTypes.string,
  designSystem: PropTypes.bool,
}

Radio.defaultProps = {
  handleOnChange: () => {},
}

export default Radio
